module.exports = __webpack_public_path__ + "img/dry.90b356e9.svg";